import React from 'react';
import { Select } from 'antd';
import {
  BANKCHECK,
  BANKDEPOSIT,
  BILLETBANK,
  CASH,
  CREDITCARD,
  DEBITCARD,
  ELECTRONICTRANSFER,
  OTHER,
  PIX
} from 'constants/types';
import display from 'constants/display';

const { Option } = Select;

const items = [
  PIX,
  CASH,
  BANKCHECK,
  CREDITCARD,
  DEBITCARD,
  BANKDEPOSIT,
  BILLETBANK,
  ELECTRONICTRANSFER,
  OTHER
];

const SelectPaymentMethod = ({ ignoreds = [], width, ...rest }, ref) => {
  return (
    <Select {...rest} ref={ref}>
      {items
        .filter((c) => !ignoreds.includes(c))
        .map((c) => (
          <Option key={c} value={c}>
            {display[c]}
          </Option>
        ))}
    </Select>
  );
};

export default React.forwardRef(SelectPaymentMethod);
